import React from 'react';
import PropTypes from 'prop-types';

export const IconRoulette = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    height="34"
    viewBox="0 0 43 44"
    fill="none"
  >
    <g clipPath="url(#roulette_1)">
      <path d="M21.393 43.2143C9.74204 43.2143 0.178711 33.6521 0.178711 22C0.178711 10.3479 9.74204 0.785706 21.393 0.785706C33.0439 0.785706 42.6073 10.3479 42.6073 22C42.6073 33.6521 33.0439 43.2143 21.393 43.2143Z" fill="url(#roulette_2)" />
      <path d="M21.3929 39.1834C11.9557 39.1834 4.20947 31.4381 4.20947 22C4.20947 12.5619 11.9557 4.81659 21.3929 4.81659C30.8301 4.81659 38.5763 12.5619 38.5763 22C38.5763 31.4381 30.8301 39.1834 21.3929 39.1834Z" fill="#FDFFD3" />
      <path d="M22.308 11.0527C21.784 10.5943 21.0017 10.5943 20.4777 11.0527C15.4971 15.4111 11.665 17.9738 11.665 22.1211C11.665 25.3928 14.0041 28.0799 17.2238 28.0799C18.2411 28.0799 19.1779 27.8026 20.0032 27.2663V30.5119H18.6135C17.846 30.5119 17.2238 31.1341 17.2238 31.9016C17.2238 32.6691 17.846 33.2913 18.6135 33.2913H24.1722C24.9397 33.2913 25.5619 32.6691 25.5619 31.9016C25.5619 31.1341 24.9397 30.5119 24.1722 30.5119H22.7826V27.2663C23.6078 27.8026 24.5446 28.0799 25.5619 28.0799C28.7818 28.0799 31.1207 25.3925 31.1207 22.1211C31.1207 17.9729 27.2885 15.4109 22.308 11.0527Z" fill="url(#roulette_3)" />
    </g>
  </svg>
);

IconRoulette.propTypes = {
  className: PropTypes.string,
};

IconRoulette.defaultProps = {
  className: '',
};
